import React, {useState, useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import Footer from "../../../components/user/Footer/Footer";
import restApi from '../../../api/Source';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../../../components/user/LoadingSpinner/LoadingSpinner';
import Badge from 'react-bootstrap/Badge';
import Header from "../../../components/user/Header/Header";

import './Product.css';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
}));

function Product(props) {

    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState();

    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState([]);
    const [parts, setParts] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
    const [oemNumbers, setOemNumbers] = useState([]);
    const [commercialAdaos, setCommercialAdaos] = useState(0);

    // the code of the product from url
    const { supplierId, productCode } = useParams();

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    useEffect(() => {
        window.scroll(0, 0);
        if (localStorage.getItem("commercialAdaos") !== null && localStorage.getItem("commercialAdaos") !== undefined) {
            setCommercialAdaos(localStorage.getItem("commercialAdaos"));
        }
        setLoading(true);
        restApi.get("/services/articles?includeCrossReferences=" + true + "&&articleNumber=" + productCode).then(products => {
            setProducts(products.data);
            products.data.map((item) => {
                if (decodeURIComponent(productCode) === item.articleNumber && Number(decodeURIComponent(supplierId)) === item.supplierId) {
                    console.log("DAAA");
                    setProduct(item);
                    restApi.get("/services/articles/" + item.id + "/parts").then(partsResponse => {
                        setParts(partsResponse);
                        console.log(partsResponse);
                        setLoading(false);
                    }).catch(error => {
                        setLoading(false);
                        setError(error);
                        if (error.response.status === 401) {
                            navigateTo('/');
                        }
                    });
                    setProductDetails(item.articleCriteria != null ? item.articleCriteria.split(';') : []);
                    setOemNumbers(item.oemNumbers != null ? item.oemNumbers.split('\n') : []);
                    if (oemNumbers.length === 1) {
                        oemNumbers = item.oemNumbers != null ? item.oemNumbers.split(';') : [];
                    }
                }
            });
        }).catch(error => {
            setLoading(false);
            setError(error);
            if (error.response.status === 401) {
                navigateTo('/');
            }
        });
    }, []);

    const navigateTo = (page) => {
        props.history.push(page);
    }
    
    if (localStorage.getItem("isAuthenticated") === false || localStorage.getItem("userRole") !== "USER") {
        navigateTo('/');
    }

    const addToCart = (product) => {
        props.addToCart(product);
    }

    const setPart = (part) => {
        setLoading(true);
        restApi.get("/services/article/" + part.articleNumber + "/sup/" + part.supplierId).then(relatedProduct => {
            setProduct(relatedProduct.data);
        }).catch(error => {
            setLoading(false);
            setError(error);
        });
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    
    return (
        <div className="page-container">
            <div id="content-wrap">
                <Header {...props} />
                {isLoading === true && 
                    <LoadingSpinner />
                }
                {isLoading === false && 
                <div className="container-fluid mt-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm mb-4">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
                                            {product.media && product.media.type === "1" ? (
                                                <div className="product-img mb-3">
                                                    <img 
                                                        src={`/media/img/${product.media.source}`} 
                                                        className="img-fluid" 
                                                        alt={product.productName}
                                                        style={{ maxHeight: '300px', objectFit: 'contain' }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: '300px' }}>
                                                    <span className="text-muted">Fără imagine</span>
                                                </div>
                                            )}
                                            <div className="product-info">
                                                <h4 className="font-weight-bold mb-2">{product.productName}</h4>
                                                <p className="text-muted mb-1">{product.supplierBrand}</p>
                                                <p className="text-secondary small">{product.articleNumber}</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 mb-4 mb-md-0">
                                            <h6 className="font-weight-bold mb-3">Stoc disponibil</h6>
                                            <div className="mb-3">
                                                {product.stockBG1 !== null && product.stockBG1 > 0 && (
                                                    <Badge variant="success" className="mr-2 mb-2" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>
                                                        BG1: {product.stockBG1}
                                                    </Badge>
                                                )}
                                                {product.stockBG2 !== null && product.stockBG2 > 0 && (
                                                    <Badge variant="info" className="mb-2" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>
                                                        BG2: {product.stockBG2}
                                                    </Badge>
                                                )}
                                                {(!product.stockBG1 || product.stockBG1 === 0) && (!product.stockBG2 || product.stockBG2 === 0) && (
                                                    <p className="text-muted">Nu este disponibil în stoc</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <h6 className="font-weight-bold mb-3">Preț</h6>
                                            <div className="mb-4">
                                                <p className="mb-2">
                                                    <small className="text-muted">Pret cu TVA: </small>
                                                    <strong className="text-success" style={{ fontSize: '1.3rem' }}>
                                                        {commercialAdaos > 0 
                                                            ? (product.price + (product.price * commercialAdaos / 100)).toFixed(2)
                                                            : product.price.toFixed(2)
                                                        } RON
                                                    </strong>
                                                </p>
                                            </div>
                                            <button 
                                                type="button" 
                                                className="btn btn-primary btn-lg btn-block" 
                                                onClick={() => addToCart(product)}
                                            >
                                                Adauga in cos
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="mb-3">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Typography className={classes.heading}>Detalii Produs</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div" style={{ width: '100%' }}>
                                        {productDetails && productDetails.length > 0 ? (
                                            <ul className="list-group list-group-flush">
                                                {productDetails.map((detail, idx) => (
                                                    <li key={idx} className="list-group-item">{detail}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">Nu sunt disponibile detalii pentru acest produs.</p>
                                        )}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className="mb-3">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                >
                                    <Typography className={classes.heading}>Coduri OE</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div" style={{ width: '100%' }}>
                                        {oemNumbers && oemNumbers.length > 0 ? (
                                            <ul className="list-group list-group-flush">
                                                {oemNumbers.map((oemNumber, idx) => (
                                                    <li key={idx} className="list-group-item">{oemNumber}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">Nu sunt disponibile coduri OE pentru acest produs.</p>
                                        )}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className="mb-3">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                > 
                                    <Typography className={classes.heading}>Echivalente</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div" style={{ width: '100%' }}>
                                        {products && products.length > 0 ? (
                                            <div className="row">
                                                {products.map((prod, idx) => (
                                                    <div key={idx} className="col-12 mb-3">
                                                        <div className="card shadow-sm">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-12 col-md-8">
                                                                        <a 
                                                                            href={`/product/${prod.supplierId}/${prod.articleNumber}`} 
                                                                            className="text-decoration-none text-dark"
                                                                            onClick={(e) => { e.preventDefault(); setProduct(prod); }}
                                                                        >
                                                                            <h6 className="font-weight-bold mb-1">{prod.productName}</h6>
                                                                            <p className="text-muted small mb-1">{prod.supplierBrand}</p>
                                                                            <p className="text-secondary small mb-0">{prod.articleNumber}</p>
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-12 col-md-4 text-md-right">
                                                                        <p className="mb-2">
                                                                            <strong className="text-success">
                                                                                {commercialAdaos > 0 
                                                                                    ? (prod.price + (prod.price * commercialAdaos / 100)).toFixed(2)
                                                                                    : prod.price.toFixed(2)
                                                                                } RON
                                                                            </strong>
                                                                        </p>
                                                                        <div>
                                                                            {prod.stockBG1 !== null && prod.stockBG1 > 0 && (
                                                                                <Badge variant="success" className="mr-1">BG1: {prod.stockBG1}</Badge>
                                                                            )}
                                                                            {prod.stockBG2 !== null && prod.stockBG2 > 0 && (
                                                                                <Badge variant="info">BG2: {prod.stockBG2}</Badge>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-muted">Nu sunt disponibile echivalente pentru acest produs.</p>
                                        )}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel4bh-content"
                                    id="panel4bh-header"
                                >
                                    <Typography className={classes.heading}>Piese in set</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography component="div" style={{ width: '100%' }}>
                                        {parts !== null && parts.length > 0 ? (
                                            <div className="row">
                                                {parts.map((part, idx) => (
                                                    <div key={idx} className="col-12 mb-3">
                                                        <div className="card shadow-sm">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-12 col-md-8">
                                                                        <a 
                                                                            href="#" 
                                                                            className="text-decoration-none text-dark"
                                                                            onClick={(e) => { e.preventDefault(); setPart(part); }}
                                                                        >
                                                                            <h6 className="font-weight-bold mb-1">{part.productName}</h6>
                                                                            <p className="text-muted small mb-1">{part.supplierBrand}</p>
                                                                            <p className="text-secondary small mb-0">{part.articleNumber}</p>
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-12 col-md-4 text-md-right">
                                                                        <p className="mb-2">
                                                                            <strong className="text-success">{product.price} RON</strong>
                                                                        </p>
                                                                        <div>
                                                                            {product.stockBG1 !== null && product.stockBG1 > 0 && (
                                                                                <Badge variant="success" className="mr-1">BG1: {product.stockBG1}</Badge>
                                                                            )}
                                                                            {product.stockBG2 !== null && product.stockBG2 > 0 && (
                                                                                <Badge variant="info">BG2: {product.stockBG2}</Badge>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-muted">Nu sunt disponibile piese în set pentru acest produs.</p>
                                        )}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>
                </div>}
            </div>
            <Footer />
        </div>
    );
}

export default withRouter(Product);